import { defineComponent as _defineComponent } from 'vue'
import { CardData } from '~/composables/useCardData';

export default /*#__PURE__*/_defineComponent({
  __name: 'CardNewLabel',
  props: {
    item: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})